import { createTheme } from '@mui/material';

export const muiTheme = createTheme({
  typography: {
    fontFamily: 'OptumSans, sans-serif',
  },
});
